/**
 * Orden y etiquetas como hoja DETALLE_OTO (Excel).
 * Las claves `key` deben coincidir con el JSON de la Lambda POST /marketing/panel-base.
 */
export const DETALLE_OTO_COLUMNS = [
  { key: 'RUT', header: 'RUT', format: 'text', rutWide: true },
  { key: 'CLIENTE', header: 'CLIENTE', format: 'text' },
  { key: 'EJECUTIVO', header: 'EJECUTIVO', format: 'text' },
  { key: 'EQUIPO', header: 'EQUIPO', format: 'text' },
  { key: 'LINEA', header: 'LINEA', format: 'text' },
  { key: 'TAMAÑO', header: 'TAMAÑO', format: 'text' },
  { key: 'TAMAÑO FINAL', header: 'TAMAÑO FINAL', format: 'text' },
  { key: 'ESTADO CLAVE', header: 'ESTADO CLAVE', format: 'text' },
  { key: 'OTO SEMESTRE (TOTAL)', header: 'OTO SEMESTRE (TOTAL)', format: 'money' },
  { key: 'OTO MES PASADO (OTROS)', header: 'OTO MES PASADO (OTROS)', format: 'money' },
  { key: 'OTO MES PASADO (FE Y FP)', header: 'OTO MES PASADO (FE Y FP)', format: 'money' },
  { key: 'OTO MES PASADO (TOTAL)', header: 'OTO MES PASADO (TOTAL)', format: 'money' },
  { key: 'CESIONES BANCO', header: 'CESIONES BANCO', format: 'money' },
  { key: 'CESIONES IF', header: 'CESIONES IF', format: 'money' },
  { key: 'CESIONES IF FINAL', header: 'CESIONES IF FINAL', format: 'money' },
  { key: 'CESIONES OTRO', header: 'CESIONES OTRO', format: 'money' },
  { key: 'PARTICIPACIÓN IF/OTROS', header: 'PARTICIPACIÓN IF/OTROS', format: 'ratioPercent' },
  { key: 'PARTICIPACIÓN FINAL', header: 'PARTICIPACIÓN FINAL', format: 'ratioPercent' },
  { key: 'TIPO PARTICIPACIÓN', header: 'TIPO PARTICIPACIÓN', format: 'text' },
  { key: 'DELTA', header: 'DELTA', format: 'decimal' },
  { key: 'META_PER', header: 'META_PER', format: 'decimal' },
  { key: 'META_MONTO', header: 'META_MONTO', format: 'money' },
  { key: 'BLOQUEO GERENCIA', header: 'BLOQUEO GERENCIA', format: 'text' },
  { key: 'FILTRO LINEA', header: 'FILTRO LINEA', format: 'text' },
  { key: 'FILTRO: NORMALIZACIÓN', header: 'FILTRO: NORMALIZACIÓN', format: 'text' },
  { key: 'FILTRO: BLOQUEO GERENCIA', header: 'FILTRO: BLOQUEO GERENCIA', format: 'text' },
  { key: 'FILTRO: FAM COBRANZA', header: 'FILTRO: FAM COBRANZA', format: 'text' },
  { key: 'CONTAR FILTRO', header: 'CONTAR FILTRO', format: 'integer' },
  { key: 'ESTADO FILTRO FINAL', header: 'ESTADO FILTRO FINAL', format: 'text' },
  { key: 'ESTADO EJECUTIVO', header: 'ESTADO EJECUTIVO', format: 'text' },
  { key: 'RESPONSABLE MGC', header: 'RESPONSABLE MGC', format: 'text' },
  { key: 'CONTAR RESPONSABLE', header: 'CONTAR RESPONSABLE', format: 'integer' },
  { key: 'CATEGORÍA PENETRACIÓN', header: 'CATEGORÍA PENETRACIÓN', format: 'text' },
  { key: 'OFERTA', header: 'OFERTA', format: 'text' },
];
